// extracted by mini-css-extract-plugin
export var bodySections = "_b0-8";
export var gray = "_b0-7";
export var green = "_b0-4";
export var iconContainer = "_b0-9";
export var iconWidgetContainer = "_b0-1";
export var phoneIcon = "_b0-2";
export var red = "_b0-5";
export var statusDot = "_b0-3";
export var widgetContainer = "_b0-0";
export var yellow = "_b0-6";